/*
 * View for the title of the sortable list
 */

define([
  "jquery",
  "marionette",
  "modules/shared/sortableList/sortableListTitle/template/sortableListTitleTemplate.html",
], function ($, Marionette, SortableListTitleTemplate) {
  "use strict";

  const SortableListTitleView = {};

  SortableListTitleView.sortableListTitleView = Marionette.ItemView.extend({
    template: SortableListTitleTemplate,
    modelEvents: {
      change: "render",
    },
    events: {
      "click .downloadButton.icon-download": "download",
    },
    triggers: {
      "click .data-csv": "download:all:csv",
      "click .data-xlsx": "download:all:xlsx",
      "click .all-data-csv": "download:all:csv",
      "click .all-data-xlsx": "download:all:xlsx",
      "click .filtered-data-csv": "download:filtered:csv",
    },
    download: function (event) {
      const dlEl = $("#dl" + event.target.id);
      if (dlEl.hasClass("hidden")) {
        dlEl.removeClass("hidden");
      } else {
        dlEl.addClass("hidden");
      }
    },
    hideDownloadMenu: function (downloadId) {
      $("#dl" + downloadId).addClass("hidden");
    },
  });

  return SortableListTitleView;
});
